import { render } from "./taskCenter.vue?vue&type=template&id=3c315961&scoped=true"
import script from "./taskCenter.vue?vue&type=script&lang=js"
export * from "./taskCenter.vue?vue&type=script&lang=js"

import "./taskCenter.vue?vue&type=style&index=0&id=3c315961&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c315961"]])

export default __exports__